import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { api } from './AuthContext';

const VALID_THEMES = ['dark', 'light'];
const DEFAULT_THEME = 'dark';

const ThemeContext = createContext(null);

export const ThemeProvider = ({ children }) => {
  const [theme, setThemeState] = useState(() => {
    const stored = localStorage.getItem('theme');
    return VALID_THEMES.includes(stored) ? stored : DEFAULT_THEME;
  });

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
  }, [theme]);

  const setTheme = useCallback(async (newTheme, saveToServer = false) => {
    if (!VALID_THEMES.includes(newTheme)) return;
    setThemeState(newTheme);
    localStorage.setItem('theme', newTheme);
    document.documentElement.setAttribute('data-theme', newTheme);
    if (saveToServer && api) {
      try {
        await api.put('/auth/me/theme', { theme: newTheme });
      } catch { /* silent */ }
    }
  }, [api]);

  const applyServerTheme = useCallback((serverTheme) => {
    if (serverTheme && VALID_THEMES.includes(serverTheme)) {
      setThemeState(serverTheme);
      localStorage.setItem('theme', serverTheme);
      document.documentElement.setAttribute('data-theme', serverTheme);
    }
  }, []);

  return (
    <ThemeContext.Provider value={{ theme, setTheme, applyServerTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error('useTheme must be used within ThemeProvider');
  return ctx;
};

export default ThemeContext;
